import { FONT_SCALE } from '@editor/src/page/index/components/editor/config';
import { TEXT_EFFECT_KEY, TEXT_STROKE_KEY } from '@src/slide/domain/ui-model/element-modeles/property/text/constants';
import i18n from '@i18next/i18n';
import { LineSpacingType } from '@tencent/alloy-editor';

// 用于判断当前光标位置是否超过底部时，提供少量的buffer
export const NOTE_SCROLL_PADDING = 2;

export const LINE_HEIGHT = 15;

export const getPlaceholderParagraphList = (text: string) => [{
    paragraphCharacter: {
        buNone: 1,
    },
    paragraphProps: {
        PPTLineHeight: 1,
        lineHeight: 1.2,
        lineHeightIs: 'percent',
        marginLeft: 0,
        paddingTop: 0,
        textAlign: 'left',
    },
    textRuns: [{
        text,
        styles: {
            lang: 'ea',
            color: 'rgba(0, 0, 0, 0.4)',
            fontFamily: i18n.t('微软雅黑'),
            fontSize: 7,
            fonts: { latin: i18n.t('微软雅黑'), ea: i18n.t('微软雅黑') },
        },
    }],
}];

const convertFontScale = (s) => {
    if (s.marginLeft) {
        s.marginLeft /= FONT_SCALE;
    }

    if (s.textIndent) {
        s.textIndent /= FONT_SCALE;
    }
};

const CB_OP = {
    textRun: (style, forceStyle) => ({
        ...style,
        color: 'rgba(0, 0, 0, 0.8)',
        background: 'transparent',
        fontFamily: '\'PingFang SC\', \'Microsoft YaHei\', \'微软雅黑\'',
        fontSize: 14,
        displayFontSize: 14,
        paraMaxFontSize: 14,

        // 备注中过滤掉文本效果配置
        [TEXT_EFFECT_KEY]: null,

        // 备注中过滤掉文本边框配置
        [TEXT_STROKE_KEY]: null,
        ...forceStyle?.textRunStyle,
    }),
    paragraph: (style, forceStyle) => {
        const s = {
            ...style,
            // 多倍行距，值为1.2
            lineSpacing: 1.2,
            lineSpacingRule: LineSpacingType.Multiple,

            marginLeft: 0,
            textIndent: style.textIndent ? -55 : 0,
            ...forceStyle?.paragraphStyle,
        };
        // 数据转换时乘了2,备注这里转换回去
        convertFontScale(s);

        return s;
    },
    body: (style, forceStyle) => ({
        ...style,
        ...forceStyle?.bodyStyle,
    }),
    character: (style, forceStyle) => ({
        ...style,
        fontSize: 15,
        color: 'rgba(0, 0, 0, 0.8)',
        ...forceStyle?.characterStyle,
    }),
    default: style => style,
};

export interface ForceStyle {
    textRunStyle?: {};
    paragraphStyle?: {};
    bodyStyle?: {};
    characterStyle?: {};
}

export const styleRenderCallback = (forceStyle: ForceStyle = {}) => (style, type) => (CB_OP[type]
    ? CB_OP[type](style, forceStyle)
    : CB_OP.default(style));
